export default __webpack_public_path__ + "static/media/bg_connect_wallet.5ef64bc2.png";